var _g, _defs;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgReprintTokenIcon(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Outline / Arrows /  Round Transfer Diagonal",
    clipPath: "url(#clip0_467_2414)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M4.13802 3.19243C2.7328 4.32271 1.8335 6.05642 1.8335 8.00016C1.8335 11.4059 4.59441 14.1668 8.00016 14.1668C9.09595 14.1668 10.125 13.881 11.0168 13.3799L7.08579 9.25053V11.0001C7.08579 11.2763 6.86193 11.5001 6.58579 11.5001C6.30964 11.5001 6.08579 11.2763 6.08579 11.0001V8.00013C6.08579 7.79566 6.21028 7.61179 6.40014 7.53587C6.59 7.45996 6.80695 7.50729 6.94793 7.65538L11.857 12.8122C13.2653 11.682 14.1668 9.94636 14.1668 8.00016C14.1668 4.59441 11.4059 1.8335 8.00016 1.8335C6.90096 1.8335 5.86892 2.12109 4.9752 2.62514L8.75245 6.72062V5.00024C8.75245 4.72409 8.97631 4.50024 9.25245 4.50024C9.52859 4.50024 9.75245 4.72409 9.75245 5.00024V8.00024C9.75245 8.20615 9.62622 8.39101 9.43442 8.46595C9.24263 8.54089 9.02451 8.49059 8.88491 8.33922L4.13802 3.19243ZM0.833496 8.00016C0.833496 4.04212 4.04212 0.833496 8.00016 0.833496C11.9582 0.833496 15.1668 4.04212 15.1668 8.00016C15.1668 11.9582 11.9582 15.1668 8.00016 15.1668C4.04212 15.1668 0.833496 11.9582 0.833496 8.00016Z",
    fill: "#1A1B1D",
    fillOpacity: 0.7
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_467_2414"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 16,
    height: 16,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgReprintTokenIcon);
export default __webpack_public_path__ + "static/media/reprint-tokenIcon.965e73f71fa92a1a2a1a49fff917406d.svg";
export { ForwardRef as ReactComponent };